import(/* webpackMode: "eager" */ "/home/runner/work/geounique/geounique/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/geounique/geounique/src/components/ui/BackButton.tsx");
